import { render, staticRenderFns } from "./ExtraInfo.vue?vue&type=template&id=0a78395e&scoped=true"
import script from "./ExtraInfo.vue?vue&type=script&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&lang=js"
import style0 from "./ExtraInfo.vue?vue&type=style&index=0&id=0a78395e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a78395e",
  null
  
)

export default component.exports